import { Routes, Route } from 'react-router-dom';

import { paths } from 'data/routes';
import { useColumns } from 'data/tableData/catalogue/catalogsColumns';
import { data } from 'data/mockData/catalogs.mock';

import { Manage } from 'sections/Manage';

import { Table } from 'components/Table';
import { TabType } from 'components/Tabs';

import { Data } from './components/Data';

export function Catalogs(): React.ReactElement {
  const tabs: TabType[] = [
    {
      id: 1,
      title: 'Data',
      content: <Data />,
    },
  ];

  const columns = useColumns();

  return (
    <Routes>
      <Route path="/">
        <Route index element={<Table columns={columns} data={data} />} />

        <Route path={paths.manage} element={<Manage title="Catalogs" tabs={tabs} />} />
      </Route>
    </Routes>
  );
}
